import PropTypes from 'prop-types';
import _ from 'lodash';

import Button from '../../themed/button';
import Form from '../../common/form';

import { getPipingAnomalyClassOptions } from '../../../utils/data';
import { getFileUploadTypes } from '../../../utils/utilities';
import { CoverDataItem } from '../../../utils/models';
import { FVI_SCHEMA } from '../../../utils/constants';

import toastService from '../../../services/toastService';
import withAnomalySchema from '../../hoc/withAnomalySchema';

class EditAnomalyItemUTM extends Form {
	state = {
		data: {
			id: 0,
			location: '',
			description: [],
			recommendation: [],
			class: '',
			generalImage: [],
			closeImage: [],
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = FVI_SCHEMA;

	static propTypes = {
		anomalyItem: PropTypes.object.isRequired,
		onEdit: PropTypes.func,
		onCancelEdit: PropTypes.func,
		options: PropTypes.array,
	};

	componentDidMount(): void {
		if (this.props.anomalyItem) {
			this.setState({ 
				data: {
					id: this.props.anomalyItem.id,
					location: this.props.anomalyItem.location.includes(',') ? this.props.anomalyItem.location.split(',')[0] : this.props.anomalyItem.location,
					description: this.props.anomalyItem.description,
					recommendation: this.props.anomalyItem.recommendation,
					class: this.props.anomalyItem.class,
					generalImage: this.props.anomalyItem.generalImage,
					closeImage: this.props.anomalyItem.closeImage
				} 
			});
		}
	}

	componentDidUpdate(prevProps: Readonly<any>, prevState: Readonly<{ data: any; errors: any; progress: number; loading: boolean; touched?: boolean; }>, snapshot?: any): void {
		if (!_.isEqual(this.schema, this.props.schema)) {
			this.schema = this.props.schema;
		}
	}

	doSubmit = (): void => {
		this.props.onEdit(this.state.data);
		toastService.success('Anomaly Item Updated Successfully!');
	};

	mapAnomalyClasses = () => {
		return _.map(getPipingAnomalyClassOptions(), (item) => _.pick(item, ['id', 'name']))
	};

	getSelectedClassDescription = () => {
		const classMatch = _.find(getPipingAnomalyClassOptions(), ['id', this.state.data.class]);
		if (classMatch) return classMatch.descriptions;

		return [];
	};
	
	getSelectedClassRecommendations = () => {
		const classMatch = _.find(getPipingAnomalyClassOptions(), ['id', parseInt(this.state.data.class)]);
		if (classMatch) return classMatch.recommendations;

		return [];
	};

	render() {
		return (
			<form autoComplete="off" onSubmit={this.handleSubmit}>
				<div className="row">
					<div className="col">
						{this.renderSelect({
							options: this.props.options.map((option: CoverDataItem) => ({ id: option.value, name: option.label })),
							name: 'location',
							placeholder: 'Select Anomaly Location',
							label: 'Anomaly Location',
						})}
					</div>

					<div className="col">
						{this.renderSelect({
							name: 'class',
							placeholder: 'Select Class',
							label: 'Class',
							options: this.mapAnomalyClasses(),
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderCreatableMultiselect({
							closeMenuOnSelect: true,
							options: this.getSelectedClassDescription(),
							name: 'description',
							placeholder: 'Enter Anomaly Description',
							label: 'Anomaly Description',
							isMulti: true,
						})}
					</div>

					<div className="col">
						{this.renderCreatableMultiselect({
							closeMenuOnSelect: true,
							options: this.getSelectedClassRecommendations(),
							name: 'recommendation',
							placeholder: 'Enter Remark & Recommendation',
							label: 'Remark & Recommendation',
							isMulti: true,
						})}
					</div>
				</div>

				<div className="divider my-4"></div>

				<div className="row">
					<div className="col">
						{this.renderFileInput({
							max: this.props.max,
							multiple: this.props.max > 1,
							hideCaption: true,
							name: 'generalImage',
							accept: 'image/*,application/pdf',
							label: 'Anomaly Image (General View)',
							sublabel: 'Upload photos showing general view',
							types: getFileUploadTypes(),
						})}
					</div>

					<div className="col">
						{this.renderFileInput({
							max: this.props.max,
							multiple: this.props.max > 1,
							hideCaption: true,
							name: 'closeImage',
							accept: 'image/*,application/pdf',
							label: 'Anomaly Image (Close View)',
							sublabel: 'Upload photos showing close view',
							types: getFileUploadTypes(),
						})}
					</div>
				</div>

				<div className="divider mt-4"></div>

				<div className="d-flex justify-content-end">
					{this.renderButton('Update Anomaly Item')}

					<div className="mx-4">
						<Button
							label="Cancel"
							style={{ backgroundColor: 'red' }}
							onClick={this.props.onCancelEdit}
						/>
					</div>
				</div>
			</form>
		);
	}
}

export default withAnomalySchema(EditAnomalyItemUTM);
